import React from 'react';
import GiftIcon from '../GiftIcon';
import { useVerifyServer } from '../../hooks/useVerifyServer';
import { LangContext } from '../../contexts/LangContext';
import './CartItem.css';

export const isEventItem = (item) => !item.sku.includes('pack');

export default function CartItem({ item, qty, server, isSeason = false, onRemove, onQtyChange }) {
  const serverMap = useVerifyServer(server);
  const { t } = React.useContext(LangContext);
  const type = isEventItem(item) ? 'event' : 'np';
  const visibleGifts = (item.gifts || []).filter(g => g.icon && g.icon !== 'npextra.png');

  const itemImage = isSeason ? 'img/loki/loki_chest.png' : item.image;

  return (
    <div className={`cart-item${isSeason ? ' cart-item--season' : ''}`}>
      {type === 'event' ? (
        <div className="event-image-wrapper">
          <img
            src={itemImage}
            alt={item.name}
          />
        </div>
      ) : (
        <img src={itemImage} alt={item.name} className="item-image-np" />
      )}

      <div className="item-info">
        {type === 'event' && (
          <div className="item-badge-wrapper">
            <img src="img/tag.png" alt={t.component.packCard.badge} className={`item-badge-img${isSeason ? ' item-badge-img--season' : ''}`} />
            <span className="item-badge-text">{t.component.packCard.badge}</span>
          </div>
        )}
        <span className="item-name">{item.name} - {type === 'event'
            ? `${item.npPrice} NP`
            : `${item.npAmount} NP`}</span>

        {type === 'event' && visibleGifts.length > 0 && (
          <div className="item-gifts-row">
            {visibleGifts.map((gift, i) => (
              <GiftIcon key={i} gift={gift} server={serverMap} />
            ))}
          </div>
        )}
      </div>

      <div className="item-right">
        <span className="item-price">{item.brlPrice}</span>

        <div className="qty-row">
          <button className="qty-btn" onClick={() => onQtyChange(item.sku, qty - 1)}>−</button>
          <div className="qty-value">{qty}</div>
          <button className="qty-btn" onClick={() => onQtyChange(item.sku, Math.min(qty + 1, 120))}>+</button>
        </div>

        <button className="delete-btn" onClick={() => onRemove(item.sku)}>
          <img src="img/icons/thrash.png" alt="remover" className="trash-icon" />
        </button>
      </div>
    </div>
  );
}
